import { Typography } from "@mui/joy";
import { Box, DialogContent, alpha } from "@mui/material";
import DialogClose from "atoms/DialogClose/DialogClose";
import { Internal } from "entities/internal";
import { getInternal } from "entities/internal/helper";
import { useMissionControlModeTint } from "hooks/Layout/v2";
import hotkeys from "hotkeys-js";
import { useDispatch, useSelector } from "react-redux";
import {
  formOpenSelector,
  missionControlModeSelector,
  setFormOpen,
} from "reducers/rhapsody";
import {
  internalPositionForLookupSelector,
  layoutInternalSelector,
  layoutUtilsSelector,
  selectionSelector,
  setInternalPositionForLookup,
} from "reducers/v2/missionControl";
import { useSections } from "redux/section/sectionHooks";
import { CHAIR_WIDTH, Position } from "./position";

/**
 *
 * @returns {ReactElement} ChairsLookup page
 */
export function PositionLookup() {
  const internalPositionForLookup = useSelector(
    internalPositionForLookupSelector
  );

  console.log(internalPositionForLookup);
  const { firstChairID, chairIDs } = internalPositionForLookup;
  const selection = useSelector(selectionSelector);
  const open = useSelector(formOpenSelector("positionLookup"));
  const { sectionsMap } = useSections();
  const utils = useSelector(layoutUtilsSelector);
  const internal = useSelector(layoutInternalSelector);
  const dispatch = useDispatch();
  const missionControlModeTint = useMissionControlModeTint();
  const missionControlMode = useSelector(missionControlModeSelector);
  let className = "";
  if (missionControlMode === "edit") className = "missionControlEdit";
  if (missionControlMode === "invite") className = "missionControlInvite";

  const onClose = () => {
    dispatch(setFormOpen({ isOpen: false, formID: "positionLookup" }));
    dispatch(setInternalPositionForLookup());
  };

  hotkeys("esc", close);

  const getPosition = (workSessionID, projectpieceID) => {
    const pChairIDs = chairIDs.filter((c) => {
      const _chair = utils.chairsMap[c];
      return (
        _chair?.workSessionIDs.includes(workSessionID) &&
        _chair?.projectPieceID === projectpieceID
      );
    });

    if (pChairIDs.length === 0)
      return (
        <Typography level="body2">
          <i>Not Playing</i>
        </Typography>
      );

    const iUtils = {
      ...utils,
      chairs: utils.chairs.filter((c) => pChairIDs.includes(c.id)),
    };

    const i = new Internal(
      getInternal(iUtils, workSessionID, projectpieceID),
      iUtils,
      selection
    );

    return (
      <Position
        internalPosition={i.positions[0]}
        disableLookup
        utils={utils}
        internal={internal}
      />
    );
  };

  const firstChair = utils.chairsMap[firstChairID];

  return (
    <DialogClose
      onClose={onClose}
      open={open}
      PaperComponent={Box}
      disableAutoFocus
      disableEnforceFocus
      disableRestoreFocus
      // disablePortal
      // fullWidth
      maxWidth="lg"
    >
      <Typography
        sx={{ color: "white" }}
        level="h5"
        startDecorator={<i className="fa-solid fa-chair"></i>}
      >
        {`${firstChair.orderString()} ${
          sectionsMap[firstChair.sectionID].name
        }`}
      </Typography>
      <DialogContent
        className={className}
        sx={{
          background: "white",
          mt: 2,
          position: "relative",
          borderRadius: "8px",
          overflowY: "auto",
          padding: 0,
        }}
      >
        <Box sx={{ display: "flex" }}>
          <Box
            sx={{
              width: 180,
              flexShrink: 0,
              position: "sticky",
              left: 0,
              zIndex: 999,
              background: "white",
              borderRight: "solid 1px #e0e0e0",

              p: 1,
            }}
          >
            Pieces / Work Sessions
          </Box>
          {utils.workSessions.map((w) => (
            <Box
              key={w.id}
              sx={{
                width: CHAIR_WIDTH + 24,
                flexShrink: 0,
                p: 1,
              }}
            >
              <Typography>{w.title}</Typography>
              <Typography level="body2">{w.formatDateRange()}</Typography>
            </Box>
          ))}
        </Box>
        {utils.projectPieces.map((p) => {
          const piece = utils.piecesMap[p.pieceID];
          return (
            <Box
              key={p.id}
              sx={{ display: "flex", borderTop: "solid 1px #e0e0e0" }}
            >
              <Box
                sx={{
                  width: 180,
                  flexShrink: 0,
                  position: "sticky",
                  left: 0,
                  zIndex: 999,
                  minHeight: 150,
                  background: "white",
                  borderRight: "solid 1px #e0e0e0",
                  p: 1,
                }}
              >
                <Typography>{piece?.name ?? "Seating assignment"}</Typography>
                <Typography level="body2">{piece?.composer}</Typography>
              </Box>
              {utils.workSessions.map((w) => (
                <Box
                  key={w.id}
                  sx={{
                    background: alpha(missionControlModeTint, 0.05),
                    width: CHAIR_WIDTH + 24,
                    flexShrink: 0,
                    p: 1,
                    minHeight: 150,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {getPosition(w.id, p.id)}
                </Box>
              ))}
            </Box>
          );
        })}
      </DialogContent>
    </DialogClose>
  );
}
